import { render, staticRenderFns } from "./UserTicketStatus.vue?vue&type=template&id=f9ab9c58"
import script from "./UserTicketStatus.vue?vue&type=script&lang=js"
export * from "./UserTicketStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports